import { jurisdictionOptions, stateOptions } from "../../features/filter-sheets/definitions";
import { yearBuiltOptions } from "../../utils/helperUtils";

export const DisableDateTypeEnum = {
    DATES_BEFORE_NOW: "dates-before-now",
};

export const states = [...stateOptions];

export const jurisdictions = [...jurisdictionOptions];

export const years = [...yearBuiltOptions];

export const countries = [
    { value: "US", label: "United States" },
    { value: "CA", label: "Canada" },
];

export const errored_config = {
    FAILED: {
        Unsorted: [
            {
                label: "Category",
                field: "associatedPropertyType",
                options: [
                    { value: "REAL_PROPERTY", label: "Real estate" },
                    { value: "PERSONAL_PROPERTY", label: "Personal" },
                ],
                type: "select",
                errorMessage: "This is required field!",
            },
            {
                label: "Type",
                field: "documentType",
                options: [
                    { value: "TAX_BILL", label: "Tax bill" },
                    { value: "HEARING_NOTICE", label: "Hearing notices" },
                    { value: "VALUE_NOTICE", label: "Value notice" },
                    { value: "TAX_RETURN", label: "Tax return" },
                    { value: "CHECK", label: "Check" },
                    { value: "MISCELLANEOUS", label: "Miscellaneous" },
                ],
                type: "select",
                errorMessage: "This is required field!",
            },
        ],
        Duplicate: [
            {
                label: "Category",
                field: "associatedPropertyType",
                options: [
                    { value: "REAL_PROPERTY", label: "Real estate" },
                    { value: "PERSONAL_PROPERTY", label: "Personal" },
                ],
                type: "select",
                disabled: true,
            },
            {
                label: "Type",
                field: "documentType",
                options: [
                    { value: "TAX_BILL", label: "Tax bill" },
                    { value: "HEARING_NOTICE", label: "Hearing notices" },
                    { value: "VALUE_NOTICE", label: "Value notice" },
                    { value: "TAX_RETURN", label: "Tax return" },
                    { value: "CHECK", label: "Check" },
                    { value: "MISCELLANEOUS", label: "Miscellaneous" },
                ],
                type: "select",
                disabled: true,
            },
        ],
        Combined: [
            {
                label: "Category",
                field: "associatedPropertyType",
                options: [
                    { value: "REAL_PROPERTY", label: "Real estate" },
                    { value: "PERSONAL_PROPERTY", label: "Personal" },
                ],
                type: "select",
                disabled: true,
            },
            {
                label: "Type",
                field: "documentType",
                options: [
                    { value: "TAX_BILL", label: "Tax bill" },
                    { value: "HEARING_NOTICE", label: "Hearing notices" },
                    { value: "VALUE_NOTICE", label: "Value notice" },
                    { value: "TAX_RETURN", label: "Tax return" },
                    { value: "CHECK", label: "Check" },
                    { value: "MISCELLANEOUS", label: "Miscellaneous" },
                ],
                type: "select",
                disabled: true,
            },
        ],
    },
};

export const config = {
    REAL_PROPERTY: {
        TAX_BILL: [
            {
                label: "Category",
                field: "associatedPropertyType",
                options: [
                    { value: "REAL_PROPERTY", label: "Real estate" },
                    { value: "PERSONAL_PROPERTY", label: "Personal" },
                ],
                type: "select",
                errorMessage: "This is required field!",
            },
            {
                label: "Type",
                field: "documentType",
                options: [
                    { value: "TAX_BILL", label: "Tax bill" },
                    { value: "HEARING_NOTICE", label: "Hearing notices" },
                    { value: "VALUE_NOTICE", label: "Value notice" },
                    { value: "TAX_RETURN", label: "Tax return" },
                    { value: "CHECK", label: "Check" },
                    { value: "MISCELLANEOUS", label: "Miscellaneous" },
                ],
                type: "select",
                errorMessage: "This is required field!",
            },
            {
                label: "Tax Year",
                field: "taxYear",
                options: [...years],
                type: "select",
            },
            {
                label: "Parcel number",
                field: "parcelNumber",
                type: "input",
            },
            {
                label: "Receive date",
                field: "receiveDate",
                type: "date",
            },
            {
                label: "Due date",
                field: "dueDate",
                type: "date",
            },
            {
                label: "Earliest payment due date",
                field: "earliestPaymentDueDate",
                type: "date",
            },
            {
                label: "Company name",
                field: "companyName",
                type: "input",
            },
            {
                label: "Invoice number",
                field: "invoiceNumber",
                type: "input",
            },
            {
                label: "Address",
                field: "address",
                type: "address",
            },
            {
                label: "Jurisdiction",
                field: "jurisdiction",
                options: [...jurisdictions],
                type: "select-search",
            },
            {
                label: "State",
                field: "state",
                options: [...states],
                type: "select-search",
            },
            {
                label: "Tax district",
                field: "taxDistrict",
                type: "input",
            },
            {
                label: "Total tax owned",
                field: "totalTaxesOwedAmount",
                type: "input-number",
                prefix: "$",
            },
            {
                label: "Discount",
                field: "discounts",
                type: "input-number",
                suffix: "%",
            },
            {
                label: "True amount due",
                field: "trueAmountDueAmount",
                type: "input-number",
                prefix: "$",
            },
            {
                label: "No of payments",
                field: "numberOfPayments",
                type: "input",
            },
            {
                label: "Assessed value",
                field: "assessedValueAmount",
                type: "input-number",
                prefix: "$",
            },
        ],
        HEARING_NOTICE: [
            {
                label: "Category",
                field: "associatedPropertyType",
                options: [
                    { value: "REAL_PROPERTY", label: "Real estate" },
                    { value: "PERSONAL_PROPERTY", label: "Personal" },
                ],
                type: "select",
                errorMessage: "This is required field!",
            },
            {
                label: "Type",
                field: "documentType",
                options: [
                    { value: "TAX_BILL", label: "Tax bill" },
                    { value: "HEARING_NOTICE", label: "Hearing notices" },
                    { value: "VALUE_NOTICE", label: "Value notice" },
                    { value: "TAX_RETURN", label: "Tax return" },
                    { value: "CHECK", label: "Check" },
                    { value: "MISCELLANEOUS", label: "Miscellaneous" },
                ],
                type: "select",
                errorMessage: "This is required field!",
            },
            {
                label: "Tax Year",
                field: "taxYear",
                options: [...years],
                type: "select",
            },
            {
                label: "Parcel number",
                field: "parcelNumber",
                type: "input",
            },
            {
                label: "Receive date",
                field: "receiveDate",
                type: "date",
            },
            {
                label: "Due date",
                field: "dueDate",
                type: "date",
            },
            {
                label: "Date of hearing",
                field: "dateOfHearing",
                type: "date",
            },
            {
                label: "Company name",
                field: "companyName",
                type: "input",
            },
            {
                label: "Appeal number",
                field: "appealNumber",
                type: "input",
            },
            {
                label: "Jurisdiction",
                field: "jurisdiction",
                options: [...jurisdictions],
                type: "select-search",
            },
            {
                label: "State",
                field: "state",
                options: [...states],
                type: "select-search",
            },
        ],
        VALUE_NOTICE: [
            {
                label: "Category",
                field: "associatedPropertyType",
                options: [
                    { value: "REAL_PROPERTY", label: "Real estate" },
                    { value: "PERSONAL_PROPERTY", label: "Personal" },
                ],
                type: "select",
                errorMessage: "This is required field!",
            },
            {
                label: "Type",
                field: "documentType",
                options: [
                    { value: "TAX_BILL", label: "Tax bill" },
                    { value: "HEARING_NOTICE", label: "Hearing notices" },
                    { value: "VALUE_NOTICE", label: "Value notice" },
                    { value: "TAX_RETURN", label: "Tax return" },
                    { value: "CHECK", label: "Check" },
                    { value: "MISCELLANEOUS", label: "Miscellaneous" },
                ],
                type: "select",
                errorMessage: "This is required field!",
            },
            {
                label: "Tax Year",
                field: "taxYear",
                options: [...years],
                type: "select",
            },
            {
                label: "Parcel number",
                field: "parcelNumber",
                type: "input",
            },
            {
                label: "Receive date",
                field: "receiveDate",
                type: "date",
            },
            {
                label: "Due date",
                field: "dueDate",
                type: "date",
            },
            {
                label: "Appeal deadline",
                field: "appealDeadline",
                type: "date",
            },
            {
                label: "Address",
                field: "address",
                type: "address",
            },
            {
                label: "Jurisdiction",
                field: "jurisdiction",
                options: [...jurisdictions],
                type: "select-search",
            },
            {
                label: "Country",
                field: "country",
                options: [...countries],
                type: "select",
            },
            {
                label: "State",
                field: "state",
                options: [...states],
                type: "select-search",
            },
            {
                label: "Tax type",
                field: "taxType",
                type: "input",
            },
            {
                label: "Tax bill estimate",
                field: "taxBillEstimateAmount",
                type: "input-number",
                prefix: "$",
            },
            {
                label: "Assessed value",
                field: "assessedValueAmount",
                type: "input-number",
                prefix: "$",
            },
            {
                label: "Building value",
                field: "buildingValueAmount",
                type: "input-number",
                prefix: "$",
            },
            {
                label: "Land value",
                field: "landValueAmount",
                type: "input-number",
                prefix: "$",
            },
            {
                label: "Property description",
                field: "propertyDescription",
                type: "input",
            },
        ],
        TAX_RETURN: [
            {
                label: "Category",
                field: "associatedPropertyType",
                options: [
                    { value: "REAL_PROPERTY", label: "Real estate" },
                    { value: "PERSONAL_PROPERTY", label: "Personal" },
                ],
                type: "select",
                errorMessage: "This is required field!",
            },
            {
                label: "Tax Year",
                field: "taxYear",
                options: [...years],
                type: "select",
            },
            {
                label: "Type",
                field: "documentType",
                options: [
                    { value: "TAX_BILL", label: "Tax bill" },
                    { value: "HEARING_NOTICE", label: "Hearing notices" },
                    { value: "VALUE_NOTICE", label: "Value notice" },
                    { value: "TAX_RETURN", label: "Tax return" },
                    { value: "CHECK", label: "Check" },
                    { value: "MISCELLANEOUS", label: "Miscellaneous" },
                ],
                type: "select",
                errorMessage: "This is required field!",
            },
            {
                label: "Parcel number",
                field: "parcelNumber",
                type: "input",
            },
            {
                label: "Building code",
                field: "buildingCode",
                type: "input",
            },
            {
                label: "Receive date",
                field: "receiveDate",
                type: "date",
            },
            {
                label: "Due date",
                field: "dueDate",
                type: "date",
            },
            {
                label: "Address",
                field: "address",
                type: "address",
            },
            {
                label: "Jurisdiction",
                field: "jurisdiction",
                options: [...jurisdictions],
                type: "select-search",
            },
            {
                label: "State",
                field: "state",
                options: [...states],
                type: "select-search",
            },
        ],
        CHECK: [
            {
                label: "Category",
                field: "associatedPropertyType",
                options: [
                    { value: "REAL_PROPERTY", label: "Real estate" },
                    { value: "PERSONAL_PROPERTY", label: "Personal" },
                ],
                type: "select",
                errorMessage: "This is required field!",
            },
            {
                label: "Type",
                field: "documentType",
                options: [
                    { value: "TAX_BILL", label: "Tax bill" },
                    { value: "HEARING_NOTICE", label: "Hearing notices" },
                    { value: "VALUE_NOTICE", label: "Value notice" },
                    { value: "TAX_RETURN", label: "Tax return" },
                    { value: "CHECK", label: "Check" },
                    { value: "MISCELLANEOUS", label: "Miscellaneous" },
                ],
                type: "select",
                errorMessage: "This is required field!",
            },
            {
                label: "Tax Year",
                field: "taxYear",
                options: [...years],
                type: "select",
            },
            {
                label: "Parcel number",
                field: "parcelNumber",
                type: "input",
            },
            {
                label: "Receive date",
                field: "receiveDate",
                type: "date",
            },
            {
                label: "Due date",
                field: "dueDate",
                type: "date",
            },
            {
                label: "Company name",
                field: "companyName",
                type: "input",
            },
            {
                label: "Tax year",
                field: "taxYear",
                type: "input",
            },
            {
                label: "Address",
                field: "address",
                type: "address",
            },
            {
                label: "Jurisdiction",
                field: "jurisdiction",
                options: [...jurisdictions],
                type: "select-search",
            },
            {
                label: "State",
                field: "state",
                options: [...states],
                type: "select-search",
            },
            {
                label: "Reason for check",
                field: "reasonForCheck",
                type: "input",
            },
        ],
        MISCELLANEOUS: [
            {
                label: "Category",
                field: "associatedPropertyType",
                options: [
                    { value: "REAL_PROPERTY", label: "Real estate" },
                    { value: "PERSONAL_PROPERTY", label: "Personal" },
                ],
                type: "select",
                errorMessage: "This is required field!",
            },
            {
                label: "Type",
                field: "documentType",
                options: [
                    { value: "TAX_BILL", label: "Tax bill" },
                    { value: "HEARING_NOTICE", label: "Hearing notices" },
                    { value: "VALUE_NOTICE", label: "Value notice" },
                    { value: "TAX_RETURN", label: "Tax return" },
                    { value: "CHECK", label: "Check" },
                    { value: "MISCELLANEOUS", label: "Miscellaneous" },
                ],
                type: "select",
                errorMessage: "This is required field!",
            },
            {
                label: "Tax Year",
                field: "taxYear",
                options: [...years],
                type: "select",
            },
            {
                label: "Parcel number",
                field: "parcelNumber",
                type: "input",
            },
            {
                label: "Receive date",
                field: "receiveDate",
                type: "date",
            },
            {
                label: "Due date",
                field: "dueDate",
                type: "date",
            },
            {
                label: "Company name",
                field: "companyName",
                type: "input",
            },
            {
                label: "Tax year",
                field: "taxYear",
                type: "input",
            },
            {
                label: "Address",
                field: "address",
                type: "address",
            },
            {
                label: "Jurisdiction",
                field: "jurisdiction",
                options: [...jurisdictions],
                type: "select-search",
            },
            {
                label: "State",
                field: "state",
                options: [...states],
                type: "select-search",
            },
            {
                label: "Reason for check",
                field: "reasonForCheck",
                type: "input",
            },
        ],
    },
    PERSONAL_PROPERTY: {
        TAX_BILL: [
            {
                label: "Category",
                field: "associatedPropertyType",
                options: [
                    { value: "REAL_PROPERTY", label: "Real estate" },
                    { value: "PERSONAL_PROPERTY", label: "Personal" },
                ],
                type: "select",
                errorMessage: "This is required field!",
            },
            {
                label: "Type",
                field: "documentType",
                options: [
                    { value: "TAX_BILL", label: "Tax bill" },
                    { value: "HEARING_NOTICE", label: "Hearing notices" },
                    { value: "VALUE_NOTICE", label: "Value notice" },
                    { value: "TAX_RETURN", label: "Tax return" },
                    { value: "CHECK", label: "Check" },
                    { value: "MISCELLANEOUS", label: "Miscellaneous" },
                ],
                type: "select",
                errorMessage: "This is required field!",
            },
            {
                label: "Tax Year",
                field: "taxYear",
                options: [...years],
                type: "select",
            },
            {
                label: "Account number",
                field: "accountNumber",
                type: "input",
            },
            {
                label: "Building code",
                field: "buildingCode",
                type: "input",
            },
            {
                label: "Receive date",
                field: "receiveDate",
                type: "date",
            },
            {
                label: "Due date",
                field: "dueDate",
                type: "date",
            },
            {
                label: "Earliest payment due date",
                field: "earliestPaymentDueDate",
                type: "date",
            },
            {
                label: "Company name",
                field: "companyName",
                type: "input",
            },
            {
                label: "Invoice number",
                field: "invoiceNumber",
                type: "input",
            },
            {
                label: "Address",
                field: "address",
                type: "address",
            },
            {
                label: "Jurisdiction",
                field: "jurisdiction",
                options: [...jurisdictions],
                type: "select-search",
            },
            {
                label: "State",
                field: "state",
                options: [...states],
                type: "select-search",
            },
            {
                label: "Tax district",
                field: "taxDistrict",
                type: "input",
            },
            {
                label: "Total tax owned",
                field: "totalTaxesOwedAmount",
                type: "input-number",
                prefix: "$",
            },
            {
                label: "Discount",
                field: "discounts",
                type: "input-number",
                suffix: "%",
            },
            {
                label: "True amount due",
                field: "trueAmountDueAmount",
                type: "input-number",
                prefix: "$",
            },
            {
                label: "No of payments",
                field: "numberOfPayments",
                type: "input",
            },
            {
                label: "Assessed value",
                field: "assessedValueAmount",
                type: "input-number",
                prefix: "$",
            },
        ],
        HEARING_NOTICE: [
            {
                label: "Category",
                field: "associatedPropertyType",
                options: [
                    { value: "REAL_PROPERTY", label: "Real estate" },
                    { value: "PERSONAL_PROPERTY", label: "Personal" },
                ],
                type: "select",
                errorMessage: "This is required field!",
            },
            {
                label: "Type",
                field: "documentType",
                options: [
                    { value: "TAX_BILL", label: "Tax bill" },
                    { value: "HEARING_NOTICE", label: "Hearing notices" },
                    { value: "VALUE_NOTICE", label: "Value notice" },
                    { value: "TAX_RETURN", label: "Tax return" },
                    { value: "CHECK", label: "Check" },
                    { value: "MISCELLANEOUS", label: "Miscellaneous" },
                ],
                type: "select",
                errorMessage: "This is required field!",
            },
            {
                label: "Tax Year",
                field: "taxYear",
                options: [...years],
                type: "select",
            },
            {
                label: "Account number",
                field: "accountNumber",
                type: "input",
            },
            {
                label: "Receive date",
                field: "receiveDate",
                type: "date",
            },
            {
                label: "Due date",
                field: "dueDate",
                type: "date",
            },
            {
                label: "Date of hearing",
                field: "dateOfHearing",
                type: "date",
            },
            {
                label: "Company name",
                field: "companyName",
                type: "input",
            },
            {
                label: "Tenant name",
                field: "tenantName",
                type: "input",
            },
            {
                label: "Appeal number",
                field: "appealNumber",
                type: "input",
            },
            {
                label: "Jurisdiction",
                field: "jurisdiction",
                options: [...jurisdictions],
                type: "select-search",
            },
            {
                label: "State",
                field: "state",
                options: [...states],
                type: "select-search",
            },
        ],
        VALUE_NOTICE: [
            {
                label: "Category",
                field: "associatedPropertyType",
                options: [
                    { value: "REAL_PROPERTY", label: "Real estate" },
                    { value: "PERSONAL_PROPERTY", label: "Personal" },
                ],
                type: "select",
                errorMessage: "This is required field!",
            },
            {
                label: "Type",
                field: "documentType",
                options: [
                    { value: "TAX_BILL", label: "Tax bill" },
                    { value: "HEARING_NOTICE", label: "Hearing notices" },
                    { value: "VALUE_NOTICE", label: "Value notice" },
                    { value: "TAX_RETURN", label: "Tax return" },
                    { value: "CHECK", label: "Check" },
                    { value: "MISCELLANEOUS", label: "Miscellaneous" },
                ],
                type: "select",
                errorMessage: "This is required field!",
            },
            {
                label: "Tax Year",
                field: "taxYear",
                options: [...years],
                type: "select",
            },
            {
                label: "Account number",
                field: "accountNumber",
                type: "input",
            },
            {
                label: "Building code",
                field: "buildingCode",
                type: "input",
            },
            {
                label: "Receive date",
                field: "receiveDate",
                type: "date",
            },
            {
                label: "Due date",
                field: "dueDate",
                type: "date",
            },
            {
                label: "Appeal deadline",
                field: "appealDeadline",
                type: "date",
            },
            {
                label: "Address",
                field: "address",
                type: "address",
            },
            {
                label: "Jurisdiction",
                field: "jurisdiction",
                options: [...jurisdictions],
                type: "select-search",
            },
            {
                label: "Country",
                field: "country",
                options: [...countries],
                type: "select",
            },
            {
                label: "State",
                field: "state",
                options: [...states],
                type: "select-search",
            },
            {
                label: "Tax type",
                field: "taxType",
                type: "input",
            },
            {
                label: "Tax bill estimate",
                field: "taxBillEstimateAmount",
                type: "input-number",
                prefix: "$",
            },
            {
                label: "Assessed value",
                field: "assessedValueAmount",
                type: "input-number",
                prefix: "$",
            },
            {
                label: "Building value",
                field: "buildingValueAmount",
                type: "input-number",
                prefix: "$",
            },
            {
                label: "Land value",
                field: "landValueAmount",
                type: "input-number",
                prefix: "$",
            },
        ],
        TAX_RETURN: [
            {
                label: "Category",
                field: "associatedPropertyType",
                options: [
                    { value: "REAL_PROPERTY", label: "Real estate" },
                    { value: "PERSONAL_PROPERTY", label: "Personal" },
                ],
                type: "select",
                errorMessage: "This is required field!",
            },
            {
                label: "Type",
                field: "documentType",
                options: [
                    { value: "TAX_BILL", label: "Tax bill" },
                    { value: "HEARING_NOTICE", label: "Hearing notices" },
                    { value: "VALUE_NOTICE", label: "Value notice" },
                    { value: "TAX_RETURN", label: "Tax return" },
                    { value: "CHECK", label: "Check" },
                    { value: "MISCELLANEOUS", label: "Miscellaneous" },
                ],
                type: "select",
                errorMessage: "This is required field!",
            },
            {
                label: "Tax Year",
                field: "taxYear",
                options: [...years],
                type: "select",
            },
            {
                label: "Account number",
                field: "accountNumber",
                type: "input",
            },
            {
                label: "Building code",
                field: "buildingCode",
                type: "input",
            },
            {
                label: "Receive date",
                field: "receiveDate",
                type: "date",
            },
            {
                label: "Due date",
                field: "dueDate",
                type: "date",
            },
            {
                label: "Filing Due date",
                field: "filingDueDate",
                type: "date",
            },
            {
                label: "Address",
                field: "address",
                type: "address",
            },
            {
                label: "Jurisdiction",
                field: "jurisdiction",
                options: [...jurisdictions],
                type: "select-search",
            },
            {
                label: "State",
                field: "state",
                options: [...states],
                type: "select-search",
            },
        ],
        CHECK: [
            {
                label: "Category",
                field: "associatedPropertyType",
                options: [
                    { value: "REAL_PROPERTY", label: "Real estate" },
                    { value: "PERSONAL_PROPERTY", label: "Personal" },
                ],
                type: "select",
                errorMessage: "This is required field!",
            },
            {
                label: "Type",
                field: "documentType",
                options: [
                    { value: "TAX_BILL", label: "Tax bill" },
                    { value: "HEARING_NOTICE", label: "Hearing notices" },
                    { value: "VALUE_NOTICE", label: "Value notice" },
                    { value: "TAX_RETURN", label: "Tax return" },
                    { value: "CHECK", label: "Check" },
                    { value: "MISCELLANEOUS", label: "Miscellaneous" },
                ],
                type: "select",
                errorMessage: "This is required field!",
            },
            {
                label: "Tax Year",
                field: "taxYear",
                options: [...years],
                type: "select",
            },
            {
                label: "Account number",
                field: "accountNumber",
                type: "input",
            },
            {
                label: "Receive date",
                field: "receiveDate",
                type: "date",
            },
            {
                label: "Due date",
                field: "dueDate",
                type: "date",
            },
            {
                label: "Company name",
                field: "companyName",
                type: "input",
            },
            {
                label: "Tax year",
                field: "taxYear",
                type: "input",
            },
            {
                label: "Address",
                field: "address",
                type: "address",
            },
            {
                label: "Jurisdiction",
                field: "jurisdiction",
                options: [...jurisdictions],
                type: "select-search",
            },
            {
                label: "State",
                field: "state",
                options: [...states],
                type: "select-search",
            },
            {
                label: "Reason for check",
                field: "reasonForCheck",
                type: "input",
            },
            {
                label: "Check number",
                field: "checkNumber",
                type: "input",
            },
        ],
        MISCELLANEOUS: [
            {
                label: "Category",
                field: "associatedPropertyType",
                options: [
                    { value: "REAL_PROPERTY", label: "Real estate" },
                    { value: "PERSONAL_PROPERTY", label: "Personal" },
                ],
                type: "select",
                errorMessage: "This is required field!",
            },
            {
                label: "Type",
                field: "documentType",
                options: [
                    { value: "TAX_BILL", label: "Tax bill" },
                    { value: "HEARING_NOTICE", label: "Hearing notices" },
                    { value: "VALUE_NOTICE", label: "Value notice" },
                    { value: "TAX_RETURN", label: "Tax return" },
                    { value: "CHECK", label: "Check" },
                    { value: "MISCELLANEOUS", label: "Miscellaneous" },
                ],
                type: "select",
                errorMessage: "This is required field!",
            },
            {
                label: "Tax Year",
                field: "taxYear",
                options: [...years],
                type: "select",
            },
            {
                label: "Account number",
                field: "accountNumber",
                type: "input",
            },
            {
                label: "Receive date",
                field: "receiveDate",
                type: "date",
            },
            {
                label: "Due date",
                field: "dueDate",
                type: "date",
            },
            {
                label: "Company name",
                field: "companyName",
                type: "input",
            },
            {
                label: "Tax year",
                field: "taxYear",
                type: "input",
            },
            {
                label: "Address",
                field: "address",
                type: "address",
            },
            {
                label: "Jurisdiction",
                field: "jurisdiction",
                options: [...jurisdictions],
                type: "select-search",
            },
            {
                label: "State",
                field: "state",
                options: [...states],
                type: "select-search",
            },
            {
                label: "Reason for check",
                field: "reasonForCheck",
                type: "input",
            },
            {
                label: "Check number",
                field: "checkNumber",
                type: "input",
            },
        ],
    },
};

export const getDateFieldsList = () => {
    return [
        "saleDate",
        "dateClosed",
        "dateOpened",
        "dateRevised",
        "dueDate",
        "earliestPaymentDueDate",
        "receiveDate",
        "filingDueDate",
        "dateOfHearing",
    ];
};
